import { fontSizes } from "@iventis/styles/src/atomic-rules";
import { customMediaQueryMax, screenSizeBreakpoints, styled } from "@iventis/styles";
import React from "react";
import { format } from "date-fns";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { Content } from "@iventis/translations";
import { LIST_NODE_HIDE_LATEST_ACTIVITY_BREAKPOINT } from "@iventis/tree-browser";

export const StandardNodeContent: React.FC<{ tile: boolean; createdAt?: Date; updatedAt: Date; viewedAt?: Date; className?: string }> = ({
    tile,
    createdAt,
    updatedAt,
    viewedAt,
    className = "",
}) => {
    const translate = useIventisTranslate();
    return (
        <StandardNodeContentContainer tile={tile} className={className}>
            {createdAt && !viewedAt && (
                <div className="colour-on-focus created-at">{translate(Content.library.node_content.created, { createdAt: format(createdAt, "d MMM yy") })}</div>
            )}
            {viewedAt && <div className="colour-on-focus viewed-at">{translate(Content.library.node_content.last_viewed, { viewedAt: format(viewedAt, "d MMM yy HH:mm") })}</div>}
            <div className="colour-on-focus last-activity-at">
                {translate(Content.library.node_content.last_activity, { latestActivityDate: format(updatedAt, "d MMM yy HH:mm") })}
            </div>
        </StandardNodeContentContainer>
    );
};

const StandardNodeContentContainer = styled.div<{ tile: boolean }>`
    grid-column: 2; // Content should always be the last column in the node, the first is reserved for a button
    display: grid;
    > * {
        white-space: nowrap;
    }
    font-size: ${fontSizes.xSmall};

    ${({ tile }) =>
        tile
            ? `grid-template-columns: 1fr`
            : `
    grid-template-columns: 1fr 1fr;
    align-items: center;
    overflow: hidden;

    ${customMediaQueryMax(LIST_NODE_HIDE_LATEST_ACTIVITY_BREAKPOINT)} {
        display: none;
    }

    ${customMediaQueryMax(screenSizeBreakpoints.extraLarge)} {
        .created-at {
            display: none;
        }
    }`}
`;
